import React from 'react';

/**
 * Shared layout for day sub-views (same route as main grid, no URL change).
 * Use the header Back button to return to the stage grid.
 */
export default function DayPageShell({ dayNumber, children, className = '' }) {
  return (
    <div className={`main-day-view${className ? ` ${className}` : ''}`.trim()}>
      <div className="main-day-view-inner">{children}</div>
    </div>
  );
}
